import { useEffect } from "react";
import { useSpring, animated } from "@react-spring/web";

import { Box } from "@mui/material";

import characterKid from "../../../../Assets/StoryPassenger/KID_SIDE.png";
import characterPassenger from "../../../../Assets/StoryPassenger/MOM_SIDE.png";

import Message from "../../../Commons/Message";

import Backdrop from "../../../Commons/Backdrop";

import connectWithDispatch from "../../../../Hooks/connectWithDispatch";

import * as appActions from "../../../../Actions/appActions";

interface StageProps {
  stage: number;
  transition: number;
  setStory: (value: Partial<StoryType>) => void;
}

const StageThree = (props: StageProps) => {
  const { stage, transition, setStory } = props;

  useEffect(() => {
    if (transition >= 1 && transition < 4) setTimeout(() => setStory({ transition: transition + 1 }), 650);
    if (transition === 4) setTimeout(() => setStory({ transition: transition + 1 }), 1500);
    if (transition === 5) setTimeout(() => setStory({ transition: transition + 1 }), 1500);
    if (transition === 6) setTimeout(() => setStory({ stage: stage + 1, transition: 1, screen: 0 }), 1200);

    return () => {};
  }, [stage, transition, setStory]);

  const propsOpacityContainer = useSpring({
    opacity: transition >= 2 && transition < 6 ? 1 : 0,
    config: { duration: transition === 6 ? 300 : 800 },
  });

  const propsCharacterKid = useSpring({
    zIndex: -1,
    position: "absolute" as "absolute",
    left: transition >= 9 ? "-150%" : "-70%",
    width: "56.019vh",
    bottom: "-0.5em",
    config: { duration: 600 },
  });

  const propsCharacterPassenger = useSpring({
    zIndex: -1,
    position: "absolute" as "absolute",
    right: transition >= 9 ? "-150%" : "-70%",
    width: "54.815vh",
    bottom: "-0.5em",
    config: { duration: 600 },
  });

  const propsFirstMsg = useSpring({
    width: "38.8em",
    left: 0,
    position: "absolute" as "absolute",
    opacity: transition >= 3 ? 1 : 0,
    config: { duration: 300 },
  });

  const propsSecondMsg = useSpring({
    zIndex: transition >= 5 ? 10 : -1,
    width: "38.8em",
    left: 0,
    top: transition > 3 ? "calc(50vh + 13.88vh)" : "calc(50vh + 18vh)",
    position: "absolute" as "absolute",
    opacity: transition >= 5 ? 1 : 0,
    config: { duration: 600 },
  });

  return (
    <>
      {transition <= 4 && <Backdrop show={transition > 0} duration={600} from={"#000000"} to={"transparent"} />}
      {transition > 4 && <Backdrop show={transition === 6} duration={600} from={"transparent"} to={"#000000"} />}
      <Backdrop show={transition > 0} duration={600} />
      <Box style={{ ...styles.container }}>
        <animated.div style={{ ...styles.containerBox, ...propsOpacityContainer }}>
          <animated.div style={{ ...propsCharacterKid }}>
            <img src={characterKid} alt="" style={{ width: "100%" }} />
          </animated.div>
          <animated.div style={{ ...propsCharacterPassenger }}>
            <img src={characterPassenger} alt="" style={{ width: "100%" }} />
          </animated.div>
          <animated.div style={{ ...styles.chatBox }}>
            <animated.div style={{ ...propsFirstMsg }}>
              <Message name={"Claire"} message={"Mum, can we go to the Lego store please?"} />
            </animated.div>
            <animated.div style={{ ...propsSecondMsg }}>
              <Message align="right" name={"Elena"} message={"If we have the time dear"} />
            </animated.div>
          </animated.div>
        </animated.div>
      </Box>
    </>
  );
};

const styles = {
  container: {
    overflow: "hidden !important",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
  },
  containerBox: {
    position: "relative" as "relative",
    width: "38.8em",
    height: "100vh",
    display: "flex",
    zIndex: 0,
  },
  chatBox: {
    position: "relative" as "relative",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    flexDirection: "column" as "column",
  },
};

const mapStateToProps = (state: StateType) => {
  return {
    stage: state.appReducer.story.stage,
    transition: state.appReducer.story.transition,
  };
};

const mapDispatchToProps: MapDispatchToProps = {
  setStory: appActions.setStory,
};

export default connectWithDispatch(StageThree, mapStateToProps, mapDispatchToProps);
